import { SolaView, htmlSolaWithInstance } from '@hm-spt/sola';
import { ROW_NO_HEAD, rowNoCell } from '../components/row-no';
import * as api from '../api/client';
import { escapeHtml, fmtDate } from '../lib/cells';

interface PendingData {
  loading: boolean;
  error:   string;
  rows:    api.PendingPart[];
}

/**
 * 미등록 품목 — 카탈로그 인테이크(catalog_part_pending) 목록.
 *
 * 품목 확정 시 적재된 미등록 파트를 보여주는 읽기 전용 테이블.
 * (검토/승격/수정 UI 는 추후 별도 작업)
 */
export class PendingPartsView extends SolaView<PendingData> {
  constructor() {
    super();
    this.data = { loading: true, error: '', rows: [] };
  }

  override getTitle(): string {
    return '임시등록 품목 — HCLTech 어드민';
  }

  override onMount(): void {
    void this.load();
  }

  private async load(): Promise<void> {
    try {
      const rows = await api.fetchPendingParts();
      this.data = { loading: false, error: '', rows };
    } catch (err) {
      this.data = { loading: false, error: err instanceof Error ? err.message : '불러오기 실패', rows: [] };
    }
    this.rerenderBody();
  }

  private rerenderBody(): void {
    const wrap = this._rootElement?.querySelector('.pending-body');
    if (wrap) wrap.innerHTML = this.renderBody();
  }

  private renderBody(): string {
    if (this.data.loading) return `<div class="text-muted">불러오는 중…</div>`;
    if (this.data.error)   return `<div class="alert alert-error">${escapeHtml(this.data.error)}</div>`;
    if (this.data.rows.length === 0) {
      return `<div class="text-muted">임시등록 품목이 없습니다.</div>`;
    }
    const rows = this.data.rows.map((r, index) => `
      <tr>
        ${rowNoCell(0, index)}
        <td><code>${escapeHtml(r.option_part ?? '-')}</code></td>
        <td>${escapeHtml(r.description ?? '-')}</td>
        <td>${escapeHtml(r.catalog_table_name ?? '-')}</td>
        <td>${escapeHtml(r.status)}</td>
        <td>${escapeHtml(fmtDate(r.created_at))}</td>
      </tr>`).join('');
    return `
      <div class="deal-table-wrap">
        <table class="deal-items-table">
          <thead>
            <tr>
              ${ROW_NO_HEAD}
              <th>파트넘버</th>
              <th>디스크립션</th>
              <th>카테고리</th>
              <th>상태</th>
              <th>등록일</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      </div>`;
  }

  render(): HTMLElement {
    return htmlSolaWithInstance(this)`
      <div class="page page-pending">
        <header class="page-header">
          <h1>🆕 임시등록 품목</h1>
        </header>
        <section class="page-body">
          <div class="pending-body">${this.renderBody()}</div>
        </section>
      </div>
    `;
  }
}
